module.exports = __webpack_public_path__ + "static/media/alphabet_img.d79c0efc.JPG";